import { cn } from '../cn';

export interface OledDisplayProps {
  /** Two text lines, as the real 128 × 32 panel shows (not the design's four). */
  line1: { left: string; right?: string };
  line2: { left: string; right?: string };
  /** 0..1 per channel VU bars along the bottom edge. */
  vu?: [number, number];
  rec?: boolean;
  className?: string;
  /** Hide the "OLED · 128×32 · on device" micro caption. */
  bare?: boolean;
}

/**
 * SSD1306 simulator: black, border2, radius 6, 12/14 padding, amber (#F3D15A) 500 12px mono, .02em.
 * Aspect 4:1 for 128×32 (design drew 2:1 for a 128×64 it does not have).
 */
export function OledDisplay({ line1, line2, vu, rec, className, bare }: OledDisplayProps) {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {!bare && <span className="micro px-0.5 text-fg4">OLED · 128×32 · on device</span>}
      <div className="relative flex flex-col justify-between rounded border border-border2 bg-black px-3.5 py-2.5 font-mono text-base font-medium leading-[1.2] tracking-[.02em] text-oled" style={{ aspectRatio: '4 / 1', maxWidth: 320 }}>
        <div className="flex justify-between gap-2">
          <span className="truncate">{line1.left}</span>
          {line1.right !== undefined && <span className={cn('flex-none', rec && 'animate-blink')}>{line1.right}</span>}
        </div>
        <div className="flex justify-between gap-2">
          <span className="truncate">{line2.left}</span>
          {line2.right !== undefined && <span className="flex-none">{line2.right}</span>}
        </div>
        {vu && (
          <div className="absolute bottom-1 left-3.5 right-3.5 flex flex-col gap-[1px]">
            {vu.map((v, i) => (
              <div key={i} className="h-[2px] bg-oled/25">
                <div className="h-full bg-oled" style={{ width: `${Math.max(0, Math.min(1, v)) * 100}%` }} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
